export enum PresetKey {
  Last7 = "LAST_WEEK",
  Last30 = "LAST_30_DAYS",
  Last90 = "LAST_90_DAYS",
  Last12m = "LAST_12_MONTHS",
  ThisMonth = "THIS_MONTH",
  PrevMonth = "LAST_MONTH",
  ThisQuarter = "THIS_QUARTER",
  PrevQuarter = "PREV_QUARTER",
  ThisYear = "YEAR_TO_DATE",
  PrevYear = "LAST_FULL_YEAR",
  AllTime = "SINCE_BEGINNING",
  Custom = "CUSTOM",
}

export type Preset = { key: PresetKey; label: string; group: number };

export const PRESET_GROUPS: Preset[][] = [
  [
    {
      key: PresetKey.Last7,
      label: "datePicker:presetLabelLast7Days",
      group: 0,
    },
    {
      key: PresetKey.Last30,
      label: "datePicker:presetLabelLast30Days",
      group: 0,
    },
    {
      key: PresetKey.Last90,
      label: "datePicker:presetLabelLast90Days",
      group: 0,
    },
    {
      key: PresetKey.Last12m,
      label: "datePicker:presetLabelLast12Months",
      group: 0,
    },
  ],
  [
    {
      key: PresetKey.PrevMonth,
      label: "datePicker:presetLabelPrevMonth",
      group: 1,
    },
    {
      key: PresetKey.ThisMonth,
      label: "datePicker:presetLabelThisMonth",
      group: 1,
    },
    {
      key: PresetKey.PrevQuarter,
      label: "datePicker:presetLabelPrevQuarter",
      group: 1,
    },
    {
      key: PresetKey.ThisQuarter,
      label: "datePicker:presetLabelThisQuarter",
      group: 1,
    },
    {
      key: PresetKey.PrevYear,
      label: "datePicker:presetLabelPrevYear",
      group: 1,
    },
    {
      key: PresetKey.ThisYear,
      label: "datePicker:presetLabelThisYear",
      group: 1,
    },
  ],
  [
    {
      key: PresetKey.AllTime,
      label: "datePicker:presetLabelAllTime",
      group: 2,
    },
  ],
];

export const PRESET_OPTIONS_WITH_COMPARISON = [
  PresetKey.Last7,
  PresetKey.Last30,
  PresetKey.Last90,
  PresetKey.Last12m,
  PresetKey.PrevMonth,
  PresetKey.PrevQuarter,
  PresetKey.PrevYear,
];

export type TimeFilter = {
  startTimeISO: string;
  endTimeISO: string;
};

export const defaultTimeFilter: TimeFilter = {
  startTimeISO: "",
  endTimeISO: "",
};
